import React, { useEffect, useState } from 'react';
import { Button, Flex, Loader, ProviderConsumer as FluentUIThemeConsumer } from "@fluentui/react-northstar";
import { useTranslation } from 'react-i18next';
import { appState } from '../../../AppState';
import { platformService } from '../../services/platform.service';
import { clone } from "lodash";
import { IResolution, AddOrUpdateResolutionToDraftKB, CheckIfResolutionIsChanged } from './ResolutionHelper';
import { ADMINISTRATORS, ANALYSTS, KNOWLEDGEAGENT } from '../../utils/constants';
import { ResolutionDetails } from './ResolutionDetails';
import { themeNames } from '@fluentui/react-teams';

interface EditResolutionDetails{
    resolutionProp: IResolution;
    dispatch?: any;
}

export const ResolutionNote = (props: EditResolutionDetails) => {
    const state = appState();
    const api = new platformService();
    const { t } = useTranslation();
    const currentState = appState();

    const [isResolutionRole, setIsResolutionRole] = useState(false);
    const [isResetResolution, setIsResetResolution] = useState(false);
    const [enableSaveBtn, setEnableSaveBtn] = useState(false);
    const [enableCancelBtn, setEnableCancelBtn] = useState(false);
    const [updatedResolution, setUpdatedResolution] = useState<ResolutionDetail>();
    const [isResolutionDetailsLoaded,setIsResolutionDetailsLoaded] = useState(false);
    const [isSaving,setIsSaving] = useState(false);
    

    props.resolutionProp.ticketData.ResolutionCategory = clone(state.resolutionCategory.find(x=>x.Id==props.resolutionProp.ticketData?.ResolutionCategoryId));

    useEffect(()=>{
        setIsResolutionDetailsLoaded(false);
        setIsResolutionRole(currentState.userRoles.roles.some(x=>[ADMINISTRATORS,ANALYSTS,KNOWLEDGEAGENT].includes(x)));
    },[]);

    useEffect(()=>{
        if (isResetResolution) setIsResetResolution(false);
    },[isResetResolution]);


    const save = async () => {
        setIsSaving(true);
        setEnableSaveBtn(false);
        

        let _updatedResolution = clone(updatedResolution);
        
        if (isResolutionRole && _updatedResolution?.DraftKB) {
            let kbId = await AddOrUpdateResolutionToDraftKB(_updatedResolution, props.resolutionProp.ticketData, currentState, t);
            _updatedResolution.AnswerId=kbId;
        }

        if (_updatedResolution.hasOwnProperty('ResolutionCategory')) {
            delete _updatedResolution["ResolutionCategory"];
        }

        if (props.resolutionProp.ticketData.ResolutionId==null){
            let newResolution = await api.createResolutionNote({}); //Need to create empty resolution first to bring back the ID and assigned back to the ticket for creating activity log.
            await api.updateTicket(props.resolutionProp.ticketData.Id, {ResolutionId: newResolution.data.Id});
            await api.updateTicketResolutionNote(newResolution.data.Id, _updatedResolution);
        }
        else await api.updateTicketResolutionNote(props.resolutionProp.ticketData.ResolutionId, _updatedResolution);

        
        props.dispatch({type:'set-resolution', data: _updatedResolution});
        props.resolutionProp.onToolbarInteraction({ event: 'saveTicket' });
    }

    const reset = () => {
        setIsResetResolution(true);
    }


    return (<FluentUIThemeConsumer
            render={globalTheme => (
                <div className='resolution-note-activity print-hidden' style={{background : globalTheme.siteVariables.theme===themeNames.Dark ? "var(--mgt-theme-background)" : "white"}}>
                    {isSaving && 
                        <div className={`pt-5 mt-5 res-loader`}>
                            <Loader />
                        </div>
                    }
                    
                    <ResolutionDetails
                        isEndUser={props.resolutionProp.isEndUser}
                        ticketData={props.resolutionProp.ticketData}
                        resolutionNoteConfig={props.resolutionProp.resolutionNoteConfig}
                        reset={isResetResolution}
                        isReadOnly={isSaving}
                        isDialog={false}
                        setEnableSaveBtn={setEnableSaveBtn}
                        setUpdatedResolution={setUpdatedResolution}
                        resetEvent={async()=>{
                            setIsResetResolution(false);
                        }}
                        loaded={async ()=>{
                            setIsResolutionDetailsLoaded(true);
                            setIsSaving(false);
                        }}
                        change={async (data)=>{
                            let isOk = CheckIfResolutionIsChanged(props.resolutionProp.ticketData?.Resolution, data);
                            setEnableCancelBtn(isOk);
                        }}
                    />
                    
                    {(isResolutionDetailsLoaded) &&
                        <Flex gap="gap.small" className='activity-resolution-btn'>
                            <Flex.Item push>
                                <Button
                                disabled={!enableCancelBtn}
                                content={t('ticket-details.apply-template.dialog.button.cancel')}
                                onClick={()=>{reset()}}
                                />
                            </Flex.Item>
                            <Flex.Item>
                                <Button
                                disabled={!enableSaveBtn}
                                content={t('common.buttons.save')}
                                primary
                                onClick={async () => { await save(); }}
                                />
                            </Flex.Item>
                        </Flex>
                    }
                        
                </div>
            )} 
        />);
}